<template>
  <div>
    <div class="chart-container">
      <canvas id="history-ca-chart" width="275" height="190"></canvas>
      <canvas id="history-rfa-chart" width="275" height="190"></canvas>
    </div>
    <div class="img-container" v-if="loaded && chartCaSrc && chartRfaSrc">
      <img id="img-chart-ca" :src="chartCaSrc" />
      <img id="img-chart-rfa" :src="chartRfaSrc" />
    </div>
  </div>
</template>

<script>
  import Chart from "chart.js";
  import { getAdhCaRfaHistory } from "@/utils/member";

  export default {
    name: "GenerateNewsletterCharts",
    data() {
      return {
        history: [],
        loaded: false,
        chartCA: null,
        chartRFA: null,
        chartCaSrc: "",
        chartRfaSrc: "",
      }
    },
    mounted() {
      const url = new URL(window.location.href)

      getAdhCaRfaHistory(url.searchParams.get("adhGuid")).then(res => {
        this.history = res;
        this.loaded = true;
        this.showChartCA();
        this.showChartRFA();
      })
    },
    computed: {
      nlInfos() {
        return this.datas && this.datas.data ? this.datas.data : {};
      }
    },
    methods: {
      showChartCA() {
        const canvas = document.getElementById("history-ca-chart");
        if (this.chartCA) this.chartCA.destroy();

        // Récupération des données pour afficher le graphique
        const labels = this.history.map(yearObj => {
          return yearObj.Year;
        });

        const data = this.history.map(yearObj => {
          return yearObj.CA;
        });

        this.chartCA = new Chart(canvas, {
          type: 'line',
          data: {
            labels,
            datasets: [
              {
                data,
                label: "Variation CA",
                borderColor: "#8BC34A",
                backgroundColor: "#CBF38A",
                fill: false
              },
            ],
          },
          options: {
            bezierCurve: false,
            animation: false,
            //onAnimationComplete: function() {
            //  console.log("HEYYYYYY");
            //},
            //animation: {
            //  onComplete: function () {
            //    console.log("HOOOOOO")
            //  }
            //},
            legend: {
              display: true
            },
            scales: {
              yAxes: [{
                ticks: {
                  callback: function (value, index, ticks) {
                    return value.toLocaleString("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });
                  }
                },
              }],
            },
            cutoutPercentage: 80,
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  return " " + data.labels[tooltipItem.index] + " : " + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });
                }
              }
            },
          }
        });

        this.chartCaSrc = this.chartCA.toBase64Image();
      },
      showChartRFA() {
        const canvas = document.getElementById("history-rfa-chart");
        if (this.chartRFA) this.chartRFA.destroy();

        // Récupération des données pour afficher le graphique
        const labels = this.history.map(yearObj => {
          return yearObj.Year;
        });

        const data = this.history.map(yearObj => {
          return yearObj.TxRFA;
        });

        this.chartRFA = new Chart(canvas, {
          type: 'line',
          data: {
            labels,
            datasets: [
              {
                data,
                label: "Variation RFA totale (en %)",
                borderColor: "#8BC34A",
                backgroundColor: "#CBF38A",
                fill: false
              },
            ],
          },
          options: {
            animation: false,
            legend: {
              display: true
            },
            scales: {
              yAxes: [{
                ticks: {
                  callback: function (value, index, ticks) {
                    return (value / 100).toLocaleString("fr-FR", { style: "percent", maximumFractionDigits: 2, minimumFractionDigits: 2 });
                  }
                },
              }],
            },
            cutoutPercentage: 80,
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  return " " + data.labels[tooltipItem.index] + " : " + (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] / 100).toLocaleString("fr-FR", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 });
                }
              }
            },
          }
        });
        this.chartRfaSrc = this.chartRFA.toBase64Image();
      },
    }
  }
</script>

<style scoped>
  .chart-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
    width: 880px;
    margin: auto;
  }

    .chart-container canvas {
      width: 275px;
      max-width: 275px;
      height: 190px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Adherent/Newsletter/GenerateCharts.vue